<template>
  <div>
    <div v-if="isEditor">
      <Row :gutter="4">
        <h5>{{ label }}</h5>
        <Col span="24">
        <FormItem>
          <Input
            v-model.trim="myValue"
            :rows="1"
            :autosize="true"
            type="textarea"
            @on-blur="emitValue"
          >
          </Input>
        </FormItem>
      </Col>
      </Row>
    </div>
    <div v-else>
      <dl
        v-if="myValue"
        class="uk-description-list"
      >
        <dt>{{ label }}</dt>
        <dd>
          {{ myValue }}
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { strings, booleans, numbers } from '@/mixins/props/defaults'

export default {
  mixins: [
    strings('label', 'value'),
    numbers('extraId'),
    booleans('isEditor')
  ],
  data () {
    return {
      myValue: null
    }
  },
  mounted () {
    this.myValue = this.value
  },
  methods: {
    emitValue () {
      const payload = {
        id: this.extraId,
        value: this.myValue
      }
      this.$emit('value-changed', payload)
    }
  }
}
</script>
